/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'orderinstall': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<defs><path pid="0" id="svgicon_orderinstall_a" d="M0 0h20v20H0z"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon_orderinstall_b" _fill="#fff"><use xlink:href="#svgicon_orderinstall_a"/></mask><path pid="1" d="M.83 2.46c.32 0 .57.26.57.57v2.4h3.37C4.91 4.62 5.61 4 6.46 4h10.39c.95 0 1.72.77 1.72 1.72v8.02c0 .95-.77 1.72-1.72 1.72h-1.24c-.95 0-1.72-.77-1.72-1.72v-3.37c0-.31-.26-.57-.57-.57h-2.67c-.94 0-1.71-.71-1.71-1.57 0-.23-.27-.43-.58-.43h-1.9c-.78 0-1.43-.52-1.64-1.22H1.4v8.23a.57.57 0 11-1.14 0V3.03c0-.31.26-.57.57-.57zm16.017 2.686H6.457c-.31 0-.57.26-.57.57v.37c0 .32.26.57.57.57h1.91c.94 0 1.71.71 1.71 1.57 0 .23.27.43.58.43h2.66c.95 0 1.72.77 1.72 1.71v3.38c0 .31.25.57.57.57h1.24c.32 0 .58-.26.58-.57v-8.03c0-.31-.26-.57-.58-.57z" _fill="#FFF" mask="url(#svgicon_orderinstall_b)"/></g>'
  }
})
